import {
  DatePicker,
  Empty,
  Flex,
  Form,
  Progress,
  Spin,
  Table,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Button,
  Card,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import FormSelect from "../form-components/SelectComponent";
import purchaseOrderCreation from "../../api/purchase-orders/pruchaseOrderCreation";
import SearchInput from "../form-components/SearchComponent";
import { SearchOutlined } from "@ant-design/icons";
import invoiceApis from "../../api/Invoice/invoice";
import dispatchApis from "../../api/dispatch/dispatch";
import budgetApis from "../../api/master/budget";
import purchaseRequestApis from "../../api/master/purchaseRequest";
import quotationApis from "../../api/master/quotations";
import supplierApis from "../../api/master/supplier";
import usersApis from "../../api/master/users";
import materialsApis from "../../api/master/materials";
import Export from "../../components/export/Export";
import dayjs from "dayjs";
import misc from "../../api/misc/dropDowns";
import miscService from "../../api/misc/misc";
import { InfoCircleOutlined } from "@ant-design/icons";
import creditDebitNoteApis from "../../api/credit-debit-note/credit-debit-note";
import inventoryCreation from "../../api/inventory/inventoryCreation";
import boqApis from "../../api/boq/boq";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import BulkUpload from "../../components/upload/BulkUpload";
import FormMultiSelect from "../form-components/MultiSelectComponent";

import workCategoryApi from "../../api/master/workCategory";

import tenderListData from "../../pages/rate-contract/mock/tenderListData.json";
import tenderPendingApprovalListData from "../../pages/rate-contract/mock/tenderPendingApprovalListData.json";
import { count } from "console";
import { mockWorkOrdersData } from "../work-orders/mockData/viewWorkOrderData";
import { mockPendingWorkOrdersData } from "../work-orders/mockData/pendingWorkOrdersData";
import { mockWorkOrders as localMockWorkOrders } from "../work-orders/mockData/workOrderData";
import { mockWorkOrders } from "../../data/mockWorkOrders";
import {
  mockExecutionBatches,
  mockApprovedWorkLines,
} from "../../data/mockWorkExecution";
import { mockRABills } from "../../data/mockRABills";
import { mockPaymentData } from "../payments/mockData/paymentData";
import workOrderApis from "../../api/WorkOrderManagement/WorkOrderApis";
import workExecutionApis from "../../api/WorkOrderManagement/WorkExecutionApis";
import RABillApis from "../../api/WorkOrderManagement/RABillApis";
import paymentApis from "../../api/payments/payments";
import paymentsApis from "../../api/WorkOrderManagement/PaymentsApis";

const { RangePicker } = DatePicker;
type WidgetType = {
  title: string;
  key: string;
  color: string;
  percentage: number;
  value: number;
};
type SelectOptions = {
  label: string;
  value: string;
};
type SelectFilterType = {
  title: string;
  placeholder?: string;
  options: SelectOptions[];
  onChange?: (value: any) => void;
  selectionMode?: "multiple" | "single";
};
const TransactionFlowDefaultTemplate: React.FC<any> = ({
  title,
  moduleKey,
  widget,
  columns,
  sideNavigation,
  selectFilters,
  previousPath,
  extra,
  topRightJSX,
  refresh,
  components,
  rowSelection,
  form,
}: {
  title: string;
  moduleKey: string;
  columns: any[];
  sideNavigation?: any;
  widget?: {
    progressCircle?: boolean;
    isActive: boolean;
    customLayout?: boolean;
    compactGrid?: boolean;
    kpiFilter?: {
      isActive: boolean;
      options: { label: string; value: string }[];
      selectedFilter: string;
      onFilterChange: (value: string) => void;
    };
    list: WidgetType[];
  };
  selectFilters?: SelectFilterType[];
  previousPath?: string;
  topRightJSX?: any;
  extra?: {
    id?: any;
    tableScrollX?: number;
    dateRange?: boolean;
    excelExport?: boolean;
    bulkUpload?: boolean;
    dataFilterTootip?: string;
  };
  refresh?: boolean;
  components?: any;
  rowSelection?: any;
  form?: any;
}) => {
  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const [customDateRange, setCustomDateRange] = useState<any>();
  const [dataSource, setDataSource] = useState<any>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    defaultCurrent: 1,
    defaultPageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "30", "40", "50"],

    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [screenSize, setScreenSize] = useState(0);

  const [searchQuery, setsearchQuery] = useState(null);

  const selectFilter1 = watch("selectFilter1");
  const selectFilter2 = watch("selectFilter2");
  const selectFilter3 = watch("selectFilter3");
  const dateRange = watch("dateRange");

  const mockDataListAll = {
    data: {
      list: mockWorkOrders,
      count: mockWorkOrders.length,
    },
    status: true,
    message: "Success",
  };

  const mockDataList = {
    data: {
      list: mockWorkOrders.filter((wo) => wo.status === "Pending"),
      count: mockWorkOrders.filter((wo) => wo.status === "Pending").length,
    },
    status: true,
    message: "Success",
  };
  const mockDataamendList = {
    data: {
      list: mockWorkOrders.filter((wo) => wo.status === "Under Negotiation"),
      count: mockWorkOrders.filter((wo) => wo.status === "Under Negotiation")
        .length,
    },
    status: true,
    message: "Success",
  };
  const mockDataFinalList = {
    data: {
      list: mockWorkOrders.filter((wo) => wo.status === "Accepted"),
      count: mockWorkOrders.filter((wo) => wo.status === "Accepted").length,
    },
    status: true,
    message: "Success",
  };

  // Work Execution mock data
  const mockWorkExecutionUpdatesList = {
    data: {
      list: mockWorkOrders.filter(
        (wo) => wo.status === "Accepted" || wo.status === "In Execution"
      ),
      count: mockWorkOrders.filter(
        (wo) => wo.status === "Accepted" || wo.status === "In Execution"
      ).length,
    },
    status: true,
    message: "Success",
  };

  const mockWorkExecutionApprovalsList = {
    data: {
      list: mockExecutionBatches.filter(
        (batch) => batch.status === "Submitted"
      ),
      count: mockExecutionBatches.filter(
        (batch) => batch.status === "Submitted"
      ).length,
    },
    status: true,
    message: "Success",
  };

  const mockWorkExecutionClosedList = {
    data: {
      list: mockExecutionBatches.filter((batch) => batch.status === "Approved"),
      count: mockExecutionBatches.filter(
        (batch) => batch.status === "Approved"
      ),
    },
    status: true,
    message: "Success",
  };

  // RA Bills mock data
  const mockRABillsCreateList = {
    data: {
      list: [
        {
          id: "wo1",
          woNumber: "WO/2025/URB/0012",
          contractor: "ABC Infra Ltd",
          site: "Urban Rise - Tower A",
          project: "Tower Construction Phase 2",
          section: "Basement & Ground Floor",
          woTotalValue: 5000000,
          cumulativeWorkValue: 3500000,
          cumulativeWorkDone: 70.0,
          previousRABillsValue: 2500000,
          availableForBilling: 1000000,
          lastRABillDate: "2025-06-15",
          status: "In Execution",
          contractType: "Construction Work",
          payOnCompletion: false,
          softHold: false,
          hardHold: false,
          accountingPeriod: "Open",
        },
      ],
      count: 1,
    },
    status: true,
    message: "Success",
  };

  const mockRABillsPendingList = {
    data: {
      list: mockRABills.filter((bill) =>
        ["Submitted", "Checked", "Verified"].includes(bill.status)
      ),
      count: mockRABills.filter((bill) =>
        ["Submitted", "Checked", "Verified"].includes(bill.status)
      ).length,
    },
    status: true,
    message: "Success",
  };

  const mockRABillsApprovedList = {
    data: {
      list: mockRABills.filter((bill) =>
        ["Approved", "Posted", "Paid"].includes(bill.status)
      ),
      count: mockRABills.filter((bill) =>
        ["Approved", "Posted", "Paid"].includes(bill.status)
      ).length,
    },
    status: true,
    message: "Success",
  };

  const mockRABillsOutstandingList = {
    data: {
      list: mockRABills.filter(
        (bill) =>
          ["Approved", "Posted", "Paid"].includes(bill.status) &&
          bill.balanceAmount > 0
      ),
      count: mockRABills.filter(
        (bill) =>
          ["Approved", "Posted", "Paid"].includes(bill.status) &&
          bill.balanceAmount > 0
      ).length,
    },
    status: true,
    message: "Success",
  };

  const mockRABillsOverdueList = {
    data: {
      list: mockRABills.filter((bill) => {
        const currentDate = new Date();
        const approvalDate = new Date(bill.approvedOn || "");
        const expectedPaymentDate = new Date(
          approvalDate.getTime() + 30 * 24 * 60 * 60 * 1000
        ); // 30 days
        return (
          ["Approved", "Posted"].includes(bill.status) &&
          bill.balanceAmount > 0 &&
          currentDate > expectedPaymentDate
        );
      }),
      count: mockRABills.filter((bill) => {
        const currentDate = new Date();
        const approvalDate = new Date(bill.approvedOn || "");
        const expectedPaymentDate = new Date(
          approvalDate.getTime() + 30 * 24 * 60 * 60 * 1000
        );
        return (
          ["Approved", "Posted"].includes(bill.status) &&
          bill.balanceAmount > 0 &&
          currentDate > expectedPaymentDate
        );
      }).length,
    },
    status: true,
    message: "Success",
  };

  //---------------------------------------- Functions Start ----------------------------------------

  const fetchData = async (params: any) => {
    setLoading(true);
    try {
      const {
        current,
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        paginationId,
        searchQuery,
        selectFilter1,
        selectFilter2,
        selectFilter3,
        dateRange,
        customDateRange,
      } = params;
      if (
        extra?.dateRange &&
        ((dateRange == "Custom Date" && customDateRange == undefined) ||
          dateRange == undefined)
      )
        return;
      const { from, to }: any =
        dateRange !== undefined && convertToDates(dateRange);
      let apiResponse: any = {};
      switch (moduleKey) {
        case "view-all-work-orders":
          apiResponse = await workOrderApis.getWorkOrderList({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
            startDate: from,
            endDate: to,
          });
          break;
        case "new-work-orders":
          apiResponse = await workOrderApis.getWorkOrderList({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
            startDate: from,
            endDate: to,
            filterListType: "Contractor New Orders",
          });
          break;
        case "work-order-amendment":
          apiResponse = await workOrderApis.getWorkOrderList({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
            startDate: from,
            endDate: to,
            filterListType: "Contractor Amendments",
          });
          break;
        case "finalized-work-orders":
          apiResponse = await workOrderApis.getWorkOrderList({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: selectFilter1,
            startDate: from,
            endDate: to,
            filterListType: "Finalized",
          });
          break;
        case "work-execution-under-execution":
          apiResponse = await workExecutionApis.listWorkExecution({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            filterListType: "Contractor Under Executions",
          });
          break;
        case "work-execution-pending-approvals":
          apiResponse = await workExecutionApis.pendingWorkExecution({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
          });
          break;
        case "work-execution-closed-works":
          apiResponse = await workExecutionApis.closedWorkExecution({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            status: "Approved",
          });
          break;
        case "ra-bills-create":
          apiResponse = await workExecutionApis.listWorkExecution({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            filterListType: "For RaBills",
          });
          break;
        case "ra-bills-pending-approvals":
          apiResponse = await RABillApis.listRABill({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            filterListType: "Pending Approval",
          });
          break;
        case "ra-bills-view-approved":
          apiResponse = await RABillApis.listRABill({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
          });
          break;
        case "ra-bills-outstanding":
          apiResponse = await RABillApis.listRABill({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            filterListType: "OutStanding",
          });
          break;
        case "ra-bills-overdue":
          apiResponse = await RABillApis.listRABill({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            filterListType: "OverDue",
          });
          break;
        case "pending-payment-approvals":
          apiResponse = {
            data: {
              list: mockPaymentData.filter((payment) =>
                ["Submitted", "Checked", "Verified"].includes(payment.status)
              ),
              count: mockPaymentData.filter((payment) =>
                ["Submitted", "Checked", "Verified"].includes(payment.status)
              ).length,
            },
            status: true,
            message: "Success",
          };
          break;
        case "run-payments":
          apiResponse = {
            data: {
              list: mockPaymentData.filter((payment) =>
                ["Approved"].includes(payment.status)
              ),
              count: mockPaymentData.filter((payment) =>
                ["Approved"].includes(payment.status)
              ).length,
            },
            status: true,
            message: "Success",
          };
          break;
        case "view-payments":
          apiResponse = await paymentsApis.listPayment({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            startDate: from,
            endDate: to,
          });
          break;
        case "view-payments-pending":
          apiResponse = await paymentsApis.listPayment({
            sortOrder,
            pageSize,
            direction,
            pageDiff,
            paginationId,
            searchQuery,
            startDate: from,
            endDate: to,
            filterListType: "Contractor Pending Approvals",
          });
          break;
        default:
          alert("Invalid key " + moduleKey);
      }

      const { data, status } = apiResponse;
      if (status) {
        const { list, count } =
          data || apiResponse.response.data || apiResponse.response;
        setDataSource(list);
        setPagination((prev) => ({
          ...prev,
          total: Number(count),
        }));
      }
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  const convertToDates = (dateType: string) => {
    try {
      switch (dateType) {
        case "Month to Date":
          return {
            from: dayjs().startOf("month").format("YYYY-MM-DD"),
            to: dayjs().format("YYYY-MM-DD"),
          };
        case "Quarter to Date":
          return {
            from: dayjs()
              .subtract(3, "month")
              .startOf("month")
              .format("YYYY-MM-DD"),
            to: dayjs().format("YYYY-MM-DD"),
          };
        case "Year to Date":
          return {
            from: dayjs().startOf("year").format("YYYY-MM-DD"),
            to: dayjs().format("YYYY-MM-DD"),
          };
        default:
          if (!customDateRange)
            return {
              from: dayjs()?.format("YYYY-MM-DD"),
              to: dayjs()?.format("YYYY-MM-DD"),
            };
          return {
            from: dayjs(customDateRange[0]).format("YYYY-MM-DD"),
            to: dayjs(customDateRange[1]).format("YYYY-MM-DD"),
          };
      }
    } catch (error) {
      return {
        from: dayjs()?.format("YYYY-MM-DD"),
        to: dayjs()?.format("YYYY-MM-DD"),
      };
    }
  };

  const tableOnChange = async (
    newPagination: any,
    filters: any,
    sorter: any
  ) => {
    const apiParams = {
      oldPage: pagination.current,
      current: newPagination.current?.toString(),
      sortOrder: "DESC",
      pageSize: pagination.pageSize,
      direction: "P",
      pageDiff: 0,
      paginationId: null,
      searchQuery,
    };

    if (sorter.order) {
      apiParams.sortOrder = sorter.order === "ascend" ? "ASC" : "DESC";
    } else if (newPagination.pageSize != pagination.pageSize) {
      // if page size is changed
      apiParams.pageSize = newPagination.pageSize;
      const _currentPage =
        Math.floor(
          ((Number(pagination.current) - 1) * Number(pagination.pageSize)) /
            Number(newPagination.pageSize)
        ) + 1; // calculating new current page based on new page size
      apiParams.current = _currentPage;
      apiParams.pageDiff = _currentPage - 1;
    } else {
      if (newPagination.current != pagination.current) {
        apiParams.direction =
          newPagination.current > pagination.current
            ? "F" // Forward
            : "B"; // Backward
        apiParams.paginationId =
          apiParams.direction == "F"
            ? dataSource[dataSource.length - 1]?.paginationId // Last item ID for backward direction
            : dataSource[0]?.paginationId; // First item ID for forward direction

        apiParams.pageDiff =
          Math.abs(newPagination.current - pagination.current) - 1;
      }
    }

    setPagination({
      ...pagination,
      current: apiParams.current,
      pageSize: apiParams.pageSize,
    });
    await fetchData({
      ...apiParams,
      selectFilter1,
      selectFilter2,
      selectFilter3,
      dateRange,
      customDateRange,
    });
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
  };

  //---------------------------------------- Functions End----------------------------------------

  const refreshData = () => {
    fetchData({
      oldPage: 1,
      current: pagination.current.toString(),
      sortOrder: "DESC",
      pageSize: pagination.pageSize.toString(),
      direction: "P",
      pageDiff: pagination.current - 1,
      paginationId: null,
      searchQuery,
      dateRange,
      customDateRange,
    });
  };
  useEffect(() => {
    if (extra?.dateRange) {
      setValue("dateRange", "Quarter to Date");
    }
    refreshData();
  }, [refresh]);

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  useEffect(() => {
    if (
      selectFilter1 !== undefined ||
      selectFilter2 !== undefined ||
      selectFilter3 !== undefined ||
      dateRange !== undefined ||
      customDateRange !== undefined
    ) {
      setPagination({
        ...pagination,
        current: 1,
      });
      fetchData({
        oldPage: 1,
        current: pagination.current.toString(),
        sortOrder: "DESC",
        pageSize: pagination.pageSize.toString(),
        direction: "P",
        // pageDiff: pagination.current - 1,
        pageDiff: 0,
        paginationId: null,
        searchQuery,
        selectFilter1,
        selectFilter2,
        selectFilter3,
        dateRange,
        customDateRange,
      });
    }
  }, [selectFilter1, selectFilter2, selectFilter3, dateRange, customDateRange]);

  return (
    <>
      <Head title={title} />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {sideNavigation}
            <div className="card-inner card-inner-lg">
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent className="w-100">
                    <BlockTitle
                      tag="h4"
                      className="d-flex justify-content-between align-items-center  w-100"
                    >
                      <span>{title}</span>
                    </BlockTitle>
                  </BlockHeadContent>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <Button
                        className={`btn-icon btn-trigger toggle-expand me-n1`}
                      >
                        <Icon name="menu-alt-r"></Icon>
                      </Button>
                      <div className="toggle-expand-content">
                        <ul className="nk-block-tools g-3">
                          {extra?.excelExport && (
                            <li>
                              <Export
                                data={{
                                  sortOrder: "DESC",
                                  pageSize: 100,
                                  direction: "P",
                                  pageDiff: 0,
                                  searchQuery,
                                  selectFilter1,
                                  selectFilter2,
                                  selectFilter3,
                                  dateRange:
                                    dateRange && convertToDates(dateRange),
                                  customDateRange,
                                }}
                                moduleKey={moduleKey}
                              />
                            </li>
                          )}
                          {extra?.bulkUpload && (
                            <li>
                              <BulkUpload
                                moduleKey={moduleKey}
                                showAsButton={true}
                              />
                            </li>
                          )}
                          <li className="nk-block-tools-opt">{topRightJSX}</li>
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <Block>
                {widget?.isActive && (
                  <>
                    {/* KPI Filter Dropdown */}
                    {widget?.kpiFilter?.isActive && (
                      <div
                        style={{
                          marginBottom: "15px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                            color: "#495057",
                          }}
                        >
                          View KPIs:
                        </span>
                        <select
                          value={widget.kpiFilter.selectedFilter}
                          onChange={(e) =>
                            widget.kpiFilter?.onFilterChange(e.target.value)
                          }
                          style={{
                            padding: "6px 12px",
                            borderRadius: "4px",
                            border: "1px solid #d1d5db",
                            fontSize: "14px",
                            minWidth: "150px",
                            backgroundColor: "white",
                            cursor: "pointer",
                          }}
                        >
                          {widget.kpiFilter.options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* Widget Cards */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        width: "100%",
                      }}
                    >
                      {widget?.list.map((widgets, index) => (
                        <div
                          key={index}
                          style={{
                            border: widget?.compactGrid
                              ? "1px solid #e1e5eb"
                              : "1px solid #dbdfea",
                            padding: widget?.compactGrid ? "12px 16px" : "15px",
                            borderRadius: widget?.compactGrid ? "6px" : "8px",
                            backgroundColor: widget?.compactGrid
                              ? "#fafbfc"
                              : "white",
                            boxShadow: widget?.compactGrid
                              ? "0 1px 3px rgba(0,0,0,0.1)"
                              : "none",
                            width: widget?.customLayout
                              ? `calc(${100 / widget.list.length}% - 10px)` // Dynamic width for single row
                              : widget?.compactGrid
                              ? "calc(25% - 10px)" // 4 widgets per row for compact grid
                              : "calc(20% - 10px)", // Default 5 widgets per row
                            minWidth: widget?.customLayout
                              ? `${Math.min(
                                  150,
                                  Math.floor(1000 / widget.list.length)
                                )}px` // Dynamic minimum width
                              : widget?.compactGrid
                              ? "200px" // Better minimum width for compact grid
                              : "150px", // Default minimum width
                            marginBottom: "10px",
                          }}
                        >
                          <div
                            style={{
                              marginBottom: widget?.compactGrid
                                ? "8px"
                                : "20px",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {widget?.compactGrid && (widgets as any)?.icon && (
                              <span style={{ fontSize: "16px" }}>
                                {(widgets as any).icon}
                              </span>
                            )}
                            <h6
                              style={{
                                margin: 0,
                                fontSize: widget?.compactGrid ? "13px" : "14px",
                                fontWeight: widget?.compactGrid
                                  ? "600"
                                  : "normal",
                                color: "#495057",
                              }}
                            >
                              {widgets.title}
                            </h6>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {widget.progressCircle && (
                              <div style={{ flex: 1 }}>
                                <Progress
                                  type="circle"
                                  percent={
                                    Number(widgets?.percentage)
                                      ?.toFixed(2)
                                      ?.toString() as any
                                  }
                                  width={50}
                                  strokeColor={widgets.color}
                                  format={(percent) => `${Number(percent)}%`}
                                />
                              </div>
                            )}

                            <div style={{ flex: 1, textAlign: "center" }}>
                              <p
                                style={{
                                  fontSize: widget?.compactGrid
                                    ? "20px"
                                    : "24px",
                                  margin: 0,
                                  fontWeight: widget?.compactGrid
                                    ? "700"
                                    : "normal",
                                  color: widgets.color || "#495057",
                                }}
                              >
                                {widgets.value}
                              </p>
                              {widget?.compactGrid && widgets.percentage && (
                                <span
                                  style={{
                                    fontSize: "11px",
                                    color: "#6c757d",
                                    fontWeight: "500",
                                  }}
                                >
                                  ({widgets.percentage}%)
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </Block>
              <FormProvider {...methods}>
                <form className="w-100 d-flex align-items-center justify-content-start">
                  {(selectFilters && selectFilters?.length > 0) ||
                  extra?.dateRange ? (
                    <div className="d-flex align-items-start flex-wrap w-75 mb-2">
                      {/* {selectFilters && selectFilters?.length > 0 || extra?.dateRange && ( */}
                      <div className="d-flex align-items-center flex-wrap w-100">
                        {selectFilters?.map(
                          (filter: SelectFilterType, index: any) => {
                            return (
                              <div
                                key={"filters" + index}
                                className="mt-1 mb-0 w-25"
                                style={{ marginRight: 10 }}
                              >
                                {filter?.selectionMode !== "multiple" ? (
                                  <FormSelect
                                    name={`selectFilter${index + 1}`}
                                    label={filter?.title}
                                    // required={false}
                                    hideRequiredMark={true}
                                    placeholder={
                                      filter?.placeholder || filter?.title
                                    }
                                    options={filter?.options}
                                    onChange={(e: any) => {
                                      if (
                                        typeof filter.onChange === "function"
                                      ) {
                                        filter.onChange(e);
                                      }
                                    }}
                                  />
                                ) : (
                                  <FormMultiSelect
                                    name={`selectFilter${index + 1}`}
                                    label={filter?.title}
                                    // required={false}
                                    // hideRequiredMark={true}
                                    placeholder={
                                      filter?.placeholder || filter?.title
                                    }
                                    options={filter?.options}
                                    onChange={(e: any) => {
                                      if (
                                        typeof filter.onChange === "function"
                                      ) {
                                        filter.onChange(e);
                                      }
                                    }}
                                  />
                                )}
                              </div>
                            );
                          }
                        )}
                        {extra?.dateRange && (
                          <div className="w-50" style={{ display: "contents" }}>
                            <div
                              className="mt-1 mb-0 w-25"
                              style={{ marginRight: 10 }}
                            >
                              <FormSelect
                                name="dateRange"
                                required={true}
                                hideRequiredMark={true}
                                defaultValue={"Quarter to Date"}
                                // label=""
                                label={
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    Select Date Range
                                    <Tooltip title={extra?.dataFilterTootip}>
                                      <InfoCircleOutlined
                                        style={{
                                          marginLeft: 8,
                                          fontSize: 12,
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                }
                                // optionLabel="Date Range"
                                // placeholder="Select Date Range"
                                options={[
                                  {
                                    value: "Month to Date",
                                    label: "Month to Date",
                                  },
                                  {
                                    value: "Quarter to Date",
                                    label: "Quarter to Date",
                                  },
                                  {
                                    value: "Year to Date",
                                    label: "Year to Date",
                                  },
                                  {
                                    value: "Custom Date",
                                    label: "Custom Date",
                                  },
                                ]}
                              />
                            </div>
                            <div className="mt-5 mb-0">
                              {dateRange === "Custom Date" && (
                                <RangePicker
                                  value={
                                    customDateRange
                                      ? [
                                          dayjs(customDateRange[0].toDate()),
                                          dayjs(customDateRange[1].toDate()),
                                        ]
                                      : null
                                  }
                                  onChange={(dates) => {
                                    if (dates && dates[0] && dates[1]) {
                                      setCustomDateRange([dates[0], dates[1]]);
                                    } else {
                                      setCustomDateRange(null);
                                    }
                                  }}
                                  style={{ width: "100%" }}
                                />
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      {/* // )} */}
                    </div>
                  ) : null}

                  <div
                    className={`w-${
                      (selectFilters && selectFilters?.length > 0) ||
                      extra?.dateRange
                        ? "25"
                        : "100"
                    } mb-2 `}
                  >
                    <SearchInput
                      name="search"
                      placeholder="Search..."
                      width="100%"
                      prefixIcon={<SearchOutlined />}
                      onDebouncedSearch={async (value: any) => {
                        setsearchQuery(value);
                        setPagination({
                          ...pagination,
                          current: 1,
                        });
                        await fetchData({
                          oldPage: 1,
                          current: 1,
                          sortOrder: "DESC",
                          pageSize: pagination.pageSize.toString(),
                          direction: "P",
                          pageDiff: 0,
                          paginationId: null,
                          searchQuery: value,
                          selectFilter1,
                          selectFilter2,
                          selectFilter3,
                          dateRange,
                          customDateRange,
                        });
                      }}
                      debounceDelay={300} // Adjust delay as needed
                    />
                  </div>
                </form>
              </FormProvider>
              <div className="content clearfix">
                {loading == true ? (
                  <>
                    <Flex align="center" gap="middle" className="pageLoader">
                      <Spin size="large" className="m-auto" />
                    </Flex>
                  </>
                ) : dataSource?.length > 0 ? (
                  <div
                    style={{
                      width: screenSize - (sideNavigation ? 330 : 100) + "px",
                      margin: "0px auto",
                    }}
                  >
                    <Form form={form} component={false}>
                      <Table
                        className="customTable"
                        columns={columns}
                        rowSelection={rowSelection}
                        dataSource={dataSource}
                        pagination={pagination}
                        onChange={tableOnChange}
                        components={components}
                        bordered
                        size="middle"
                        scroll={{
                          x: extra?.tableScrollX || 1500,
                        }}
                      />
                    </Form>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <Empty description="No Data Found " />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Card>
      </Content>
    </>
  );
};

export default TransactionFlowDefaultTemplate;
